import { Box, Button, Stack } from "@mui/material";

type Props = {
  onExportCSV: () => void;
  onPrintLabels: () => void;
  onEditPrices: () => void;
};

const StockReceiptDetailHeader: React.FC<Props> = ({
  onExportCSV,
  onPrintLabels,
  onEditPrices,
}) => {
  return (
    <Stack direction="row" spacing={2} sx={{ mb: 2 }}>
      <Button variant="outlined" size="small" onClick={onExportCSV}>
        Export CSV
      </Button>
      <Button variant="outlined" size="small" onClick={onPrintLabels}>
        Print Labels
      </Button>
      <Button variant="outlined" size="small" onClick={onEditPrices}>
        Edit Prices
      </Button>
    </Stack>
  );
};

export default StockReceiptDetailHeader;
